<div class="col-sm">
  @if (showFinalQcColumns) {
    <p-message severity="warn">
      <i class="pi pi-info-circle"></i>
      <span>{{
        'Rolls_Display_Table_WeighedRollsWarning'
          | translateWF
            : 'Only rolls that have been weighed are shown
      below.'
      }}</span>
    </p-message>
  }

  @if (hasBundleActualWeight) {
    <p-message severity="info">
      <i class="pi pi-info-circle"></i>
      <span>
        <strong>{{ 'Rolls_Display_Table_Note' | translateWF: 'Note' }}:</strong>
        {{
          'Rolls_Display_Table_BundleWeighedNote'
            | translateWF
              : 'This bundle has been weighed. Individual roll weights shown below are estimates from roll records.
      The actual total bundle weight is shown in the footer.'
        }}
      </span>
    </p-message>
  }

  <ng-container [formGroup]="finalQcForm">
    <ng-container formArrayName="rolls">
      <p-table [value]="rollsToDisplay" [selection]="selectedRolls" (selectionChange)="onSelectionChange($event)" [dataKey]="'number'" [rowSelectable]="isRowSelectable">
        <ng-template pTemplate="header">
          <tr>
            @if (showSelectionColumn) {
              <th style="width: 4rem">
                <p-tableHeaderCheckbox [disabled]="selectionDisabled" />
              </th>
            }
            <th>{{ 'Rolls_Display_Table_No' | translateWF: 'No.' }}</th>
            <th>{{ 'Rolls_Display_Table_RollNumber' | translateWF: 'Roll Number' }}</th>
            @if (showFinalQcColumns) {
              <th>{{ 'Rolls_Display_Table_WeighedAt' | translateWF: 'Weighed At' }}</th>
            }
            @if (showFinalWeightIndicator) {
              <th style="width: 3rem; text-align: center" [pTooltip]="'Rolls_Display_Table_FinalWeightStatus' | translateWF: 'Final Weight Status'">
                <i class="pi pi-scale"></i>
              </th>
            }
            <th>{{ 'Rolls_Display_Table_Item' | translateWF: 'Item' }}</th>
            <th>{{ 'Rolls_Display_Table_Fabric' | translateWF: 'Fabric' }}</th>
            <th>{{ 'Rolls_Display_Table_Type' | translateWF: 'Type' }}</th>
            <th>{{ 'Rolls_Display_Table_Quality' | translateWF: 'Quality' }}</th>
            @if (showFinishedGoodsColumns) {
              <th>{{ 'Rolls_Display_Table_FinalWeightLb' | translateWF: 'Final Weight (lb)' }}</th>
              <th>{{ 'Rolls_Display_Table_FinalWeightKg' | translateWF: 'Final Weight (kg)' }}</th>
              <th>{{ 'Rolls_Display_Table_FinalWeightYd' | translateWF: 'Final Weight (yd)' }}</th>
              <th>{{ 'Rolls_Display_Table_LastPrintDate' | translateWF: 'Last Print Date' }}</th>
            } @else if (showFinalQcColumns) {
              <th>{{ 'Rolls_Display_Table_FinalWeightLb' | translateWF: 'Final Weight (lb)' }}</th>
              <th>{{ 'Rolls_Display_Table_FinalWeightKg' | translateWF: 'Final Weight (kg)' }}</th>
              <th>{{ 'Rolls_Display_Table_FinalWeightYd' | translateWF: 'Final Weight (yd)' }}</th>
              <th>{{ 'Rolls_Display_Table_FinalGSM' | translateWF: 'Final GSM' }}</th>
              <th>{{ 'Rolls_Display_Table_FinalWidth' | translateWF: 'Final Width' }}</th>
              <th>{{ 'Rolls_Display_Table_Category' | translateWF: 'Category' }}</th>
              <th>{{ 'Rolls_Display_Table_OnHold' | translateWF: 'On Hold' }}</th>
            } @else if (showReprocessColumns) {
              <th>{{ 'Rolls_Display_Table_WeightLb' | translateWF: 'First Weight (lb)' }}</th>
              <th>{{ 'Rolls_Display_Table_WeightKg' | translateWF: 'First Weight (kg)' }}</th>
              <th>{{ 'Rolls_Display_Table_FinalWeightLb' | translateWF: 'Final Weight (lb)' }}</th>
              <th>{{ 'Rolls_Display_Table_FinalWeightKg' | translateWF: 'Final Weight (kg)' }}</th>
              <th>{{ 'Rolls_Display_Table_FinalWeightYd' | translateWF: 'Final Weight (yd)' }}</th>
            } @else {
              <th>{{ 'Rolls_Display_Table_WeightLb' | translateWF: 'Weight (lb)' }}</th>
              <th>{{ 'Rolls_Display_Table_WeightKg' | translateWF: 'Weight (kg)' }}</th>
              <th>{{ 'Rolls_Display_Table_WeightYd' | translateWF: 'Weight (yd)' }}</th>
            }
            @if (showReprocessColumns) {
              <th>{{ 'Rolls_Display_Table_Category' | translateWF: 'Category' }}</th>
              <th>{{ 'Rolls_Display_Table_Location' | translateWF: 'Location' }}</th>
            }
            @if (showFinalQcActions) {
              <th>{{ 'Rolls_Display_Table_QCAction' | translateWF: 'QC Action' }}</th>
            }
            @if (showActions) {
              <th></th>
            }
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-roll let-i="rowIndex">
          @let rollStrict = getRollStrict(roll);
          <tr>
            @if (showSelectionColumn) {
              <td>
                @if (isRollExcluded(rollStrict) && disabledRollTooltip) {
                  <span [pTooltip]="disabledRollTooltip" tooltipPosition="right">
                    <p-tableCheckbox [value]="rollStrict" [disabled]="true" />
                  </span>
                } @else {
                  <p-tableCheckbox [value]="rollStrict" [disabled]="isRollSelectionDisabled(rollStrict)" />
                }
              </td>
            }
            @if (showFinalQcColumns) {
              <!-- The printed correlative, not the row position: this column must match the No. on the final label -->
              <td>{{ rollStrict.finalWeightOrder ?? '-' }}</td>
            } @else {
              <td>{{ i + 1 }}</td>
            }
            <td>{{ rollStrict.number }}</td>
            @if (showFinalQcColumns) {
              <td>{{ rollStrict.finalWeight?.timeStamp | guatemalaTime: 'short' }}</td>
            }
            @if (showFinalWeightIndicator) {
              <td style="text-align: center">
                @if (hasFinalWeight(rollStrict)) {
                  <i class="pi pi-check-circle text-green-500" [pTooltip]="'Rolls_Display_Table_HasFinalWeight' | translateWF: 'Has final weight'"></i>
                } @else {
                  <i class="pi pi-exclamation-circle text-orange-500" [pTooltip]="'Rolls_Display_Table_NoFinalWeight' | translateWF: 'No final weight'"></i>
                }
              </td>
            }
            <td>{{ rollStrict.itemCode }}</td>
            <td>({{ rollStrict.expectedFabricCode }}) {{ getFabric(rollStrict.expectedFabricCode!)?.longDescription }}</td>
            <td>{{ fabricFormValues[getFabric(rollStrict.expectedFabricCode!)?.fabricForm ?? 0] }}</td>
            <td>{{ rollQualityValues[rollStrict.rollQuality] || '-' }}</td>
            @if (showFinishedGoodsColumns) {
              <td>{{ getFinalWeightInLbs(rollStrict) | number: '1.0-2' }}</td>
              <td>{{ getFinalWeightInKg(rollStrict) | number: '1.0-2' }}</td>
              <td>{{ getFinalWeightInYards(rollStrict) | number: '1.0-2' }}</td>
              <td>{{ getLastLabelPrintDate(rollStrict) | date: 'short' }}</td>
            } @else if (showFinalQcColumns) {
              <td>{{ getFinalWeightInLbs(rollStrict) | number: '1.0-2' }}</td>
              <td>{{ getFinalWeightInKg(rollStrict) | number: '1.0-2' }}</td>
              <ng-container [formGroupName]="getFinalQcFormIndex(rollStrict)">
                <td>
                  <input type="number" class="p-inputtext p-component" formControlName="finalLengthInYards" style="width: 100px" />
                </td>
                <td>
                  <input type="number" class="p-inputtext p-component" formControlName="finalGsm" style="width: 100px" />
                </td>
                <td>
                  <input type="number" class="p-inputtext p-component" formControlName="finalWidth" style="width: 100px" />
                </td>
                <td>
                  <p-select
                    [options]="getCategoryOptionsForRoll(rollStrict)"
                    optionLabel="label"
                    optionValue="value"
                    formControlName="rollCategory"
                    [showClear]="true"
                    placeholder="-"
                    appendTo="body"
                    [style]="{ width: '150px' }"
                  />
                </td>
                <td class="on-hold-cell">
                  <div class="on-hold-wrapper" [class.is-on-hold]="getOnHoldValue(rollStrict)">
                    <p-toggleSwitch formControlName="hold" />
                    @if (getOnHoldValue(rollStrict)) {
                      <i class="pi pi-exclamation-triangle text-orange-500 ml-1" [pTooltip]="'Rolls_Display_Table_OnHoldWarning' | translateWF: 'This roll is on hold'"></i>
                    }
                  </div>
                </td>
              </ng-container>
            } @else if (showReprocessColumns) {
              <td>{{ hasRollWeight(rollStrict) ? (getRollWeightInLbs(rollStrict) | number: '1.0-2') : '-' }}</td>
              <td>{{ hasRollWeight(rollStrict) ? (getRollWeightInKg(rollStrict) | number: '1.0-2') : '-' }}</td>
              <td>{{ hasFinalWeight(rollStrict) ? (getFinalWeightInLbs(rollStrict) | number: '1.0-2') : '-' }}</td>
              <td>{{ hasFinalWeight(rollStrict) ? (getFinalWeightInKg(rollStrict) | number: '1.0-2') : '-' }}</td>
              <td>{{ rollStrict.finalLengthInYards ? (rollStrict.finalLengthInYards | number: '1.0-2') : '-' }}</td>
            } @else {
              <td>{{ getDisplayWeightInLbs(rollStrict) | number: '1.0-2' }}</td>
              <td>{{ getDisplayWeightInKg(rollStrict) | number: '1.0-2' }}</td>
              <td>{{ getDisplayWeightInYards(rollStrict) | number: '1.0-2' }}</td>
            }
            @if (showReprocessColumns) {
              <td>{{ getRollCategoryLabel(rollStrict) }}</td>
              <td>{{ locationPathService.label(rollStrict.currentLocationCode, '-') }}</td>
            }
            @if (showFinalQcActions) {
              <ng-container [formGroupName]="getFinalQcFormIndex(rollStrict)">
                <td class="qc-action-cell">
                  @if (isRollAssignedToProductionCard(rollStrict)) {
                    <!-- Read-only: Roll is assigned to a production card -->
                    <div class="qc-status-display">
                      <span class="qc-status-badge" [class.approved]="rollStrict.finalQC?.isApproved" [class.rejected]="rollStrict.finalQC && !rollStrict.finalQC.isApproved">
                        {{ hasFinalQcStatus(rollStrict) ? getFinalQcStatusLabel(rollStrict) : ('Rolls_Display_Table_Assigned' | translateWF: 'Assigned') }}
                      </span>
                    </div>
                  } @else if (hasFinalQcStatus(rollStrict) && !isRollInOverrideMode(rollStrict)) {
                    <div class="qc-status-display">
                      <span class="qc-status-badge" [class.approved]="rollStrict.finalQC?.isApproved" [class.rejected]="!rollStrict.finalQC?.isApproved">
                        {{ getFinalQcStatusLabel(rollStrict) }}
                      </span>
                      <p-button [label]="'Rolls_Display_Table_Override' | translateWF: 'Override'" [text]="true" size="small" (onClick)="enableOverrideMode(rollStrict)" />
                    </div>
                  } @else {
                    <div class="qc-action-controls">
                      @if (hasPendingQcApproval(rollStrict)) {
                        <!-- Show pending status with option to change -->
                        <span class="qc-status-badge pending" [class.approved]="getPendingApprovalValue(rollStrict)" [class.rejected]="!getPendingApprovalValue(rollStrict)">
                          {{
                            getPendingApprovalValue(rollStrict)
                              ? ('Rolls_Display_Table_Approved' | translateWF: 'Approved')
                              : ('Rolls_Display_Table_Rejected' | translateWF: 'Rejected')
                          }}
                          <i class="pi pi-clock ml-1" [pTooltip]="'Rolls_Display_Table_PendingSave' | translateWF: 'Pending save'"></i>
                        </span>
                        <p-button
                          icon="pi pi-pencil"
                          [text]="true"
                          severity="secondary"
                          size="small"
                          (onClick)="clearPendingApproval(rollStrict)"
                          [pTooltip]="'Rolls_Display_Table_Change' | translateWF: 'Change'"
                        />
                      } @else {
                        <p-select [options]="finalQcOptions()" optionLabel="label" optionValue="value" formControlName="isApproved" appendTo="body" />
                      }
                      @if (isRollInOverrideMode(rollStrict)) {
                        <p-button
                          icon="pi pi-times"
                          [text]="true"
                          severity="secondary"
                          size="small"
                          (onClick)="cancelOverrideMode(rollStrict)"
                          [pTooltip]="'Rolls_Display_Table_Cancel' | translateWF: 'Cancel'"
                        />
                      }
                    </div>
                  }
                </td>
              </ng-container>
            }
            @if (showActions) {
              <td>
                <p-button icon="pi pi-trash" [text]="true" severity="danger" (onClick)="removeRollFromBundle(rollStrict.number!)" />
              </td>
            }
          </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr>
            @if (showSelectionColumn) {
              <td></td>
            }
            <td>
              @if (showSelectionColumn) {
                <strong
                  >{{ 'Rolls_Display_Table_Selected' | translateWF: 'Selected' }}: {{ getSelectedRollCount() }} / {{ getTotalRollCountFromRolls() }}
                  {{ 'Rolls_Display_Table_Rolls' | translateWF: 'rolls' }}</strong
                >
              } @else {
                <strong
                  >{{ 'Rolls_Display_Table_Total' | translateWF: 'Total' }} ({{ getTotalRollCountFromRolls() }} {{ 'Rolls_Display_Table_Rolls' | translateWF: 'rolls' }})</strong
                >
              }
            </td>
            <td></td>
            @if (showFinalQcColumns) {
              <td></td>
            }
            @if (showFinalWeightIndicator) {
              <td></td>
            }
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            @if (showFinishedGoodsColumns) {
              <td>
                <strong>{{ getTotalFinalWeightInLbs() | number: '1.0-2' }}</strong>
              </td>
              <td>
                <strong>{{ getTotalFinalWeightInKg() | number: '1.0-2' }}</strong>
              </td>
              <td>
                <strong>{{ getTotalFinalWeightInYards() | number: '1.0-2' }}</strong>
              </td>
              <td></td>
            } @else if (showFinalQcColumns) {
              <td>
                <strong>{{ getTotalFinalWeightInLbs() | number: '1.0-2' }}</strong>
              </td>
              <td>
                <strong>{{ getTotalFinalWeightInKg() | number: '1.0-2' }}</strong>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            } @else {
              @if (showSelectionColumn) {
                <td>
                  <strong>{{ getSelectedTotalFirstWeightInLbs() | number: '1.0-2' }} / {{ getTotalWeightInLbsFromRolls() | number: '1.0-2' }}</strong>
                </td>
                <td>
                  <strong>{{ getSelectedTotalFirstWeightInKg() | number: '1.0-2' }} / {{ getTotalWeightInKgFromRolls() | number: '1.0-2' }}</strong>
                </td>
                <td>
                  <strong>{{ getSelectedTotalFinalWeightInLbs() | number: '1.0-2' }} / {{ getTotalFinalWeightInLbs() | number: '1.0-2' }}</strong>
                </td>
                <td>
                  <strong>{{ getSelectedTotalFinalWeightInKg() | number: '1.0-2' }} / {{ getTotalFinalWeightInKg() | number: '1.0-2' }}</strong>
                </td>
                <td>
                  <strong>{{ getSelectedTotalWeightInYards() | number: '1.0-2' }} / {{ getTotalWeightInYards() | number: '1.0-2' }}</strong>
                </td>
              } @else {
                @if (hasBundleActualWeight) {
                  <!-- Bundle has been weighed - show actual weight -->
                  <td>
                    <strong class="text-green-700">{{ bundleActualWeightInLbs | number: '1.0-2' }}</strong>
                    <span class="text-gray-500 text-xs ml-1">({{ 'Rolls_Display_Table_Weighed' | translateWF: 'weighed' }})</span>
                  </td>
                  <td>
                    <strong class="text-green-700">{{ bundleActualWeightInKg | number: '1.0-2' }}</strong>
                  </td>
                  <td>
                    <strong>-</strong>
                  </td>
                } @else {
                  <td>
                    <strong>{{ getTotalDisplayWeightInLbs() | number: '1.0-2' }}</strong>
                  </td>
                  <td>
                    <strong>{{ getTotalDisplayWeightInKg() | number: '1.0-2' }}</strong>
                  </td>
                  <td>
                    <strong>{{ getTotalDisplayWeightInYards() | number: '1.0-2' }}</strong>
                  </td>
                }
              }
            }
            @if (showReprocessColumns) {
              <td></td>
              <td></td>
            }
            @if (showFinalQcActions) {
              <td></td>
            }
            @if (showActions) {
              <td></td>
            }
          </tr>
        </ng-template>
      </p-table>
    </ng-container>
  </ng-container>
</div>
